// src/utils/routesUtils.js
import React from "react";
import PropTypes from "prop-types";
import { Route } from "react-router-dom";

const ProcesosWrapper = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(routeProps) => {
        const { match } = routeProps;
        const { id } = match.params;

        // Solo pasamos el ID como prop
        return <Component {...routeProps} realId={id} />;
      }}
    />
  );
};

ProcesosWrapper.propTypes = {
  component: PropTypes.elementType.isRequired,
};

export const withRouteWrapper = (Component) => {
  const WrappedRoute = (props) => <ProcesosWrapper component={Component} {...props} />;
  return WrappedRoute;
};
